// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
    // API_URL: 'http://localhost:8000/',
  // API_URL: 'http://host.docker.internal:8000/',
  //API_URL: 'http://api.siyyonparvat.com/',
  // API_URL: 'https://api.mstarera.org/',
  API_URL: 'https://api.awareasso.in/',
  // API_URL: 'https://portalapi.mstarera.org/',
  app_variable: 'app1',
  // app_variable: 'app2',
  // API_URL: 'http://127.0.0.1:8000/',
  pincode_URL:'https://api.postalpincode.in/pincode/', 

  media: 'media',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
